export default __webpack_public_path__ + "static/media/KZ.M.20.2157 black1.97d8eb52.svg";